/* eslint-disable no-unused-vars */
import React from 'react';
import { hydrate } from 'react-dom';
import EntertainmentView from '../views';

const initData = JSON.parse(unescape(window.INIT_DATA));
const { context } = initData;

hydrate(
    <EntertainmentView className={`${context}__body`} context={context} {...initData} server={false} />,
    document.getElementById('root')
);
